<template>
  <div class="results-header">
    <template v-if="(hasActiveFilters && !isMobile) || (hasActiveFilters && isMobile)">
      <!-- Active filters -->
      <active-filters></active-filters>

      <!-- Clear filters (only visible on mobile) -->
      <div class="mobile-clear-search">
        <a class="basic-link" @click.prevent="clearFilters()">Tyhjennä hakuehdot</a>
      </div>
    </template>

    <div class="results-header__mobile-heading" v-if="isMobile">
      <search-heading :filters="filters" v-if="filters"></search-heading>
    </div>

    <div class="results-header__full-width">
      <!-- Listing count -->
      <div class="results-header__left-column">
        <search-heading :filters="filters" v-if="!isMobile && filters"></search-heading>
        <span class="results-header__count">
          <span class="extra-info">
            <span class="presentation-text"></span>
            <span class="large-text listings-count">{{ locationCount }}</span>
            /
          </span>
          <b class="large-text">{{ locationTotalCount }}</b>
          <b> kohdetta</b>
        </span>
      </div>

      <!-- Sorting selection -->
      <div class="results-header__sorting">
        <sorting
          v-if="filters"
          :order-by="filters.orderBy"
          :order="filters.order"
          :mode="filters.mode"
          :feature-group="filters.featureGroup"
          @sortingChanged="handleSortingChanged"
        ></sorting>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import config from '@/config';
import Sorting from '../sorting/sorting.vue';
import ActiveFilters from '../active-filters/active-filters.vue';
import SearchHeading from '../search-heading/search-heading.vue';
import searchUtils from '@/app/utils/search-utils';
import { defineComponent } from 'vue';
import type { SortingOption } from '@/config/sorting';

export default defineComponent({
  components: {
    SearchHeading,
    ActiveFilters,
    Sorting,
  },
  name: 'results-header',
  props: {
    locationTotalCount: {
      type: Number,
      required: true,
    },
    locationCount: {
      type: Number,
      required: true,
    },
    filters: {
      type: Object,
      required: false,
    },
  },
  data: () => ({
    isMobile: false,
    keys: {
      order: 'order',
      orderBy: 'orderBy',
    },
  }),
  methods: {
    clearFilters() {
      searchUtils.removeAllFilters(this.$router, this.$route);
    },
    checkIfMobile() {
      this.isMobile = window.innerWidth < config.BREAKPOINTS.TABLET_LANDSCAPE;
    },
    handleSortingChanged(sorting: SortingOption) {
      const updates = { order: sorting.order, orderBy: sorting.orderBy };
      searchUtils.addFilterToUrl(this.$router, this.$route, updates);
    },
  },
  mounted() {
    this.checkIfMobile();

    this.$bus.$on(
      'windowResized',
      () => {
        this.checkIfMobile();
      },
      this
    );
  },
  computed: {
    hasActiveFilters() {
      return searchUtils.hasActiveUserFilters(this.filters);
    },
  },
});
</script>
